import { render, staticRenderFns } from "./SceneImage.vue?vue&type=template&id=4e23a754&scoped=true&"
import script from "./SceneImage.vue?vue&type=script&lang=js&"
export * from "./SceneImage.vue?vue&type=script&lang=js&"
import style0 from "./SceneImage.vue?vue&type=style&index=0&id=4e23a754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e23a754",
  null
  
)

export default component.exports